import { render, staticRenderFns } from "./CoursewareAdminActionWidget.vue?vue&type=template&id=2cae3fc2&"
import script from "./CoursewareAdminActionWidget.vue?vue&type=script&lang=js&"
export * from "./CoursewareAdminActionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports